import script from "./invoice-detail-gt-p-upload-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-detail-gt-p-upload-dialog.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__